<script lang="ts">import { getVerbiageKey } from "../utils";
import { t, Verbiage } from "@infinitro/content";
import { ArrowIcon } from "@infinitro/icons";
import { Icon } from "@infinitro/rank-badges";
import ModalRankTable from "./modal-rank-table.svelte";
export let dropdownOpen = false;
export let rankName = $t(Verbiage[getVerbiageKey("tier_name_text")]);
export let rankBadge = "1";
export let levels = [];
const toggleDropdown = (event) => {
	event.stopPropagation();
	dropdownOpen = !dropdownOpen;
};
</script>

<div class="rank-accordion">
	<div class="custom-dropdown {dropdownOpen ? 'custom-dropdown-open' : ''}">
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<div class="dropdown-toggle" on:click={(e) => toggleDropdown(e)}>
			<div class="rank-name-container">
				<div class="badge-container">
					<Icon rank={rankBadge} level={5} size={30} />
				</div>
				<p class="rank-name {rankName.toLowerCase()}">{$t(Verbiage[rankName.toLowerCase()])}</p>
			</div>
			<div class:rotated={dropdownOpen}>
				<ArrowIcon />
			</div>
		</div>
		<div class:expanded={dropdownOpen} class="dropdown-menu">
			<div class="rank-content">
				<ModalRankTable {rankBadge} {rankName} {levels} />
			</div>
			<slot />
		</div>
	</div>
</div>

<style>
	/* rank names gradients */
	.iron {
		background: linear-gradient(45deg, #ffffff 0%, #d8d8d8 100%);
	}
	.bronze {
		background: linear-gradient(45deg, #f0cdb6 25%, #ce8b70 100%);
	}
	.silver {
		background: linear-gradient(
			90deg,
			#ececec 25%,
			#919295 42%,
			#ececec 53%,
			#919295 62%,
			#ececec 76%,
			#919295 100%
		);
	}
	.gold {
		background: linear-gradient(
			90deg,
			#ececec 5%,
			#dfb563 42%,
			#ececec 53%,
			#dfb563 70%,
			#ececec 100%
		);
	}
	.platinum {
		background: linear-gradient(
			90deg,
			#d4e0e4 5%,
			#71919e 42%,
			#d4e0e4 53%,
			#71919e 70%,
			#d4e0e4 100%
		);
	}
	.diamond {
		background: linear-gradient(
			90deg,
			#ececec 5%,
			#a1dbef 42%,
			#ececec 53%,
			#a1dbef 70%,
			#ececec 100%
		);
	}
	.titanium {
		background: linear-gradient(
			90deg,
			#ececec 5%,
			#b190c3 42%,
			#ececec 53%,
			#b190c3 70%,
			#ececec 100%
		);
	}

	/* styles */
	.rank-accordion {
		margin-bottom: 1rem;
		display: flex;
		gap: 0.75rem;
}

	.rank-name-container {
		display: flex;
		height: 3rem;
		width: 180px;
		align-items: center;
		gap: 0.5rem;
}

	.rank-name {
		--tw-bg-opacity: 1;
		background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
		font-size: 0.75rem;
		line-height: 1rem;
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
}
	@media (min-width: 1024px) {
		.rank-name {
				font-size: 1rem;
				line-height: 1.5rem;
		}
	}

	.badge-container {
		display: flex;
		height: 2.5rem;
		width: 2.5rem;
		align-items: center;
		justify-content: center;
}
	@media (min-width: 1024px) {
		.badge-container {
				height: 3rem;
				width: 3rem;
		}
	}

	.custom-dropdown {
		position: relative;
		height: -moz-fit-content;
		height: fit-content;
		width: 100%;
		overflow: hidden;
		border-radius: 0.5rem;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		font-size: 0.75rem;
		line-height: 1rem;
		font-weight: 600;
		background: var(--gradient-main);
}

	.custom-dropdown-open {
		background-color: var(--color-background-100);
		background-image: none;
}

	.dropdown-toggle {
		position: relative;
		z-index: 50;
		display: block;
		height: 3.5rem;
		width: 100%;
		cursor: pointer;
		padding: 1rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
		letter-spacing: 1.5px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
		display: flex;
		align-items: center;
		justify-content: space-between;
		overflow: hidden;
}

	.progress-bar {
		position: absolute;
		top: 0px;
		left: 0px;
		display: flex;
		height: 200%;
		min-width: 40px;
		max-width: 98%;
		justify-content: flex-end;
		background: linear-gradient(to bottom, var(--progress-color), var(--end-color));
		border-radius: 0 3rem 3rem 0;
}

	.dropdown-menu {
		position: relative;
		margin-top: -1.5rem;
		width: 100%;
		overflow: hidden;
		background-color: transparent;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		padding-top: 1.25rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		transition-property: max-height;
		transition-duration: 500ms;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		max-height: 0;
}

	.dropdown-menu.expanded {
		margin-top: -0.25rem;
		padding-top: 0px;
		background: var(--gradient-alternative);
		max-height: -moz-fit-content;
		max-height: fit-content;
}

	.d-flex {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		text-align: start;
		position: relative;
}

	.rotated {
		transform: rotate(180deg);
		transition: transform 0.3s ease;
	}

	.title {
		position: absolute;
		top: 0.875rem;
		right: 1.25rem;
		text-align: end;
		font-size: 1.125rem;
		line-height: 1.75rem;
		font-weight: 700;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
}

	.text {
		position: relative;
		z-index: 30;
		padding-top: 1rem;
		padding-bottom: 1rem;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		text-align: start;
		font-size: 0.875rem;
		line-height: 1.25rem;
		font-weight: 400;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
}

	.rank-content {
		margin-left: auto;
		margin-right: auto;
		width: 100%;
		overflow: auto;
}
</style>
